import { useNavigate } from 'react-router-dom';

export default function Hero() {
  const navigate = useNavigate();

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('https://public.readdy.ai/ai/img_res/9eff6d08f6cccbac73d72e05b711ccf7.jpg')`
      }}
    >
      <div className="text-center px-6 max-w-5xl">
        <h1 className="text-6xl md:text-7xl font-bold text-white mb-6">
          Welcome to <span className="text-purple-400">Revenant League</span>
        </h1>
        <p className="text-2xl md:text-3xl text-red-500 font-semibold mb-8">
          Rise. Compete. Conquer.
        </p>
        <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-3xl mx-auto">
          Join the ultimate competitive gaming platform. Compete in tournaments, 
          challenge rivals in money matches, and climb the leaderboards.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button 
            onClick={() => navigate('/tournaments')}
            className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-trophy-line mr-2"></i>
            Join Tournament
          </button>
          <button 
            onClick={() => navigate('/clips')}
            className="border-2 border-purple-400 text-purple-400 hover:bg-purple-400 hover:text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-play-circle-line mr-2"></i>
            Watch Clips
          </button>
        </div>
      </div>
    </section>
  );
}
